import { defineMessages } from 'react-intl';

import { ASSIGMENT_CODE } from 'src/features/pricingPlans/types';

export const pricingPlansMessages = defineMessages({
    name: {
        id: 'name',
        defineMessage: 'Name',
    },
    id: {
        id: 'id',
        defineMessage: 'Id',
    },
    changePlan: {
        id: 'change-plan',
        defaultMessage: 'Change plan',
    },
    details: {
        id: 'details',
        defaultMessage: 'Details',
    },
    pricingPlan: {
        id: 'pricing-plan',
        defaultMessage: 'Pricing plan',
    },
    pricingPlans: {
        id: 'pricing-plans',
        defaultMessage: 'Pricing plans',
    },
    planName: {
        id: 'plan-name',
        defaultMessage: 'Plan name',
    },
    initialPrice: {
        id: 'initial-price',
        defaultMessage: 'Initial price',
    },
    freeTime: {
        id: 'free-time',
        defaultMessage: 'Free time in minutes',
    },
    vat: {
        id: 'vat-amount',
        defaultMessage: 'VAT',
    },
    timeToLeave: {
        id: 'time-to-leave',
        defaultMessage: 'Time to leave in minutes',
    },
    timeToLeaveType: {
        id: 'time-to-leave-type',
        defaultMessage: 'Time to leave type',
    },
    duration: {
        id: 'duration',
        defaultMessage: 'Duration',
    },
    durationInMinutes: {
        id: 'duration-in-minutes',
        defaultMessage: 'Duration in minutes',
    },
    priceTick: {
        id: 'price-tick',
        defaultMessage: 'Price tick in minutes',
    },
    dueAmount: {
        id: 'pricing-due-amount',
        defaultMessage: 'Due amount',
    },
    inUse: {
        id: 'in-use',
        defaultMessage: 'In use',
    },
    periodStart: {
        id: 'period-start',
        defaultMessage: 'Period start',
    },
    periodEnd: {
        id: 'period-end',
        defaultMessage: 'Period end',
    },
    backPricingPlans: {
        id: 'back-pricing-plans',
        defaultMessage: 'Back to all pricing plans',
    },
    pricingPlanGlimpse: {
        id: 'pricing-plan-glimpse',
        defaultMessage: 'Pricing plan at a glimpse',
    },
    firstPeriod: {
        id: 'first-period',
        defaultMessage: 'First period',
    },
    secondPeriod: {
        id: 'second-period',
        defaultMessage: 'Second period',
    },
    thirdPeriod: {
        id: 'third-period',
        defaultMessage: 'Third period',
    },
    specialPeriod: {
        id: 'special-period',
        defaultMessage: 'Special period',
    },
    editPricingPlan: {
        id: 'edit-pricing-plan',
        defaultMessage: 'Edit pricing plan',
    },
    editPricingPlanDescription: {
        id: 'edit-pricing-plan-description',
        defaultMessage: 'Edit pricing plan details',
    },
    addPricingPlan: {
        id: 'add-pricing-plan',
        defaultMessage: 'Add pricing plan',
    },
    deletePricingPlan: {
        id: 'delete-pricing-plan',
        defaultMessage: 'Delete pricing plan',
    },
    deletePricingPlanDescription: {
        id: 'delete-pricing-plan-description',
        defaultMessage: 'Permanently delete pricing plan',
    },
    confirmDeletePricingPlan: {
        id: 'confirm-delete-pricing-plan',
        defaultMessage: 'Are you sure you want to delete the pricing plan {plan}? This action cannot be undone.',
    },
    createPricingPlanSuccess: {
        id: 'create-pricing-plan-success',
        defaultMessage: 'Pricing plan {plan_name} has been successfully created.',
    },
    updatePricingPlanSuccess: {
        id: 'update-pricing-plan-success',
        defaultMessage: 'Pricing plan {plan_name} has been successfully updated.',
    },
    deletePricingPlanSuccess: {
        id: 'delete-pricing-plan-success',
        defaultMessage: 'Pricing plan {plan_name} has been successfully deleted.',
    },
    changeAssignmentSuccess: {
        id: 'change-assignment-success',
        defaultMessage: '{planName} was changed successfully.',
    },
    reservations: {
        id: 'reservations',
        defaultMessage: 'Reservations',
    },
    createNewPricingPlan: {
        id: 'create-new-pricing-plan',
        defaultMessage: 'Create new pricing plan',
    },
    timeToLeaveNormal: {
        id: 'time-to-leave-normal',
        defaultMessage: 'Normal',
    },
    timeToLeaveFixedHour: {
        id: 'time-to-leave-fixed-hour',
        defaultMessage: 'Fixed hour',
    },
    changePlanSubtitle: {
        id: 'change-plan-subtitle',
        defaultMessage: 'Change {planName}',
    },
    allPricingPlans: {
        id: 'all-pricing-plans',
        defaultMessage: 'All pricing plans',
    },
    pricingPlansByPoints: {
        id: 'pricing-plans-by-points',
        defaultMessage: 'Pricing plans by points',
    },
    pricingPlansPoint: {
        id: 'pricing-plans-point',
        defaultMessage: 'Point',
    },
    editPricingPlanPoint: {
        id: 'edit-pricing-plan-point',
        defaultMessage: 'Edit the pricing plan for the point',
    },
    pricingPlanUpdated: {
        id: 'pricing-plan-updated',
        defaultMessage: 'Pricing plan updated',
    },
    pricingPlanUpdatedSuccessfully: {
        id: 'pricing-plan-updated-successfully',
        defaultMessage: 'The pricing plan for the point was updated successfully.',
    },
    pricingPlanEntryPoints: {
        id: 'pricing-plan-entry-points',
        defaultMessage: 'Entry points',
    },
    pricingPlanEntryPoint: {
        id: 'pricing-plan-entry-point',
        defaultMessage: 'Entry point',
    },
});

export const pricingPlanNamesMessages = defineMessages({
    [ASSIGMENT_CODE.NO_FREE_TIME]: {
        id: 'normal-plan',
        defaultMessage: 'Plan with longer free time',
    },
    [ASSIGMENT_CODE.LATE_EXIT]: {
        id: 'late-exit-plan',
        defaultMessage: 'Late exit plan',
    },
    [ASSIGMENT_CODE.LOST_TICKET]: {
        id: 'lost-ticket-plan',
        defaultMessage: 'Lost ticket plan',
    },
    [ASSIGMENT_CODE.VIP_OVER_STAY]: {
        id: 'vip-overstay-plan',
        defaultMessage: 'VIP overstay plan',
    },
});
